import { getDiceServiceUrl } from "@/constants";
import type { AllFamilySets, DiceSet } from "@/types";
import { useEffect, useState } from "react";

export const useDiceSets = (nodeEnv?: string, env?: string) => {
  const [diceSets, setDiceSets] = useState<DiceSet[]>();

  useEffect(() => {
    if (!(nodeEnv && env)) return;

    (async () => {
      setDiceSets(
        (
          (await (
            await fetch(
              `${getDiceServiceUrl(nodeEnv, env)}/dice/v1/getallfamilysets`,
            )
          ).json()) as AllFamilySets
        ).data.flatMap(({ sets: { definitionData } }) => definitionData),
      );
    })();
  }, [env, nodeEnv]);

  return diceSets;
};
